import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import MartinsRodolfo from './pages/Colabs/MartinsRodolfo'
import EliasMartins from './pages/Colabs/EliasMartins'
import CesarMarcal from './pages/Colabs/CesarMarcal'
import RamosImport from './pages/Colabs/RamosImport'
import CarPoint from './pages/Colabs/CarPoint'
import Nego from './pages/Colabs/NegoVeículos'
import CotacaoResidencial from './pages/CotacaoResidencial'

import './global.css';

function App() {
  return (
    <Router>
      <div>
        {/* Defina suas rotas aqui */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Parceiros/MartinsRodolfo" element={<MartinsRodolfo />} />
          <Route path="/Parceiros/EliasMartins" element={<EliasMartins />} />
          <Route path="/Parceiros/RamosImport" element={<RamosImport />} />
          <Route path="/Parceiros/CarPoint" element={<CarPoint />} />
          <Route path="/Parceiros/CesarMarcal" element={<CesarMarcal />} />
          <Route path="/Parceiros/negoveiculo" element={<Nego/>} />
          <Route path="/Seguro_residencial/Cotacao_residencial" element={<CotacaoResidencial />} />
        
        </Routes>
      </div>
    </Router>
  );
}

export default App;
